module.exports = __webpack_public_path__ + "img/6228f76.png";